export default __webpack_public_path__ + "static/media/marigold.cdb45553.png";